import React from "react";
import { Stepper, Step, StepLabel, StepConnector } from "@mui/material";
import { styled } from "@mui/material/styles";
import Selected from "../../images/onboard_svgs/Selected.svg";
import Skipped from "../../images/onboard_svgs/Skipped.svg";
import unveil1 from "../../images/unveil_1.png";

const Timeline = React.memo(({ steps, stepIcons, activeTab }) => {

    // Create a connector with dynamic borderColor based on the index
    const DynamicConnector = styled(StepConnector)(({ theme, stepIndex }) => ({
        "& .MuiStepConnector-line": {
            display: `block`,
            borderLeftStyle: `solid`,
            borderLeftWidth: `2px`,
            minHeight: `45px`,
            marginLeft: `3px`,
            borderColor:
                activeTab === 2 && (stepIndex === 0) ? "#45185a"
                    : activeTab === 3 && (stepIndex === 0 || stepIndex === 1) ? "#45185a"
                        : activeTab === 4 && (stepIndex === 0 || stepIndex === 1 || stepIndex === 2) ? "#45185a"
                            : "gray",
            borderLeftWidth: 2,
            height: "1.5rem",
            marginTop: `-10px`,
            marginBottom: `-10px`
        },
    }));

    // This is to immediately show the 'pending' icon for steps that are changing
    const StepIcon = React.memo(({ active, step, index }) => {
        let Icon = stepIcons.pending[index];

        if (step.isSelected) {
            Icon = Selected;
        } else if (step.isSkipped) {
            Icon = Skipped;
        } else if (step.isCurrent) {
            Icon = stepIcons.current[index];
        } else {
            Icon = stepIcons.pending[index];
        }

        return (
            <div>
                <img src={Icon} alt={`Step ${index + 1}`} />
            </div>
        );
    });
    return (<>
        <div className="px-4 pt-5 pb-12">
            <img src={unveil1} alt="unveil" className="w-[7rem]" />
        </div>
        <div className="flex justify-center items-start py-8">

            <Stepper orientation="vertical"
                connector={null}
            >
                {steps.map((step, index) => (
                    <Step key={step.label} >

                        <StepLabel
                            StepIconComponent={(props) => (
                                <StepIcon {...props} step={step} index={index} />
                            )}
                        >
                            <span
                                style={{ fontSize: '1rem' }}
                                className={`ml-2 font-nunito font-bold text-lg ${step.isCurrent || step.isSelected || step.isSkipped ? `text-[#45185a]` : `text-[#5c5e63]`}`} >
                                {step.label}
                            </span>
                        </StepLabel>
                        {index < steps.length - 1 &&
                            <DynamicConnector stepIndex={index} />
                        }

                    </Step>

                ))}
            </Stepper>
        </div>
    </>
    )
});

export default Timeline;